export enum MerchantFlags {
  ADMIN_API_DOWN_PAYMENT = "adminApiDownPayment",
  ALLOW_PRE_INSTALL_DEVICES = "AllowPreInstallDevices",
  ASK_FOR_CALL_FROM_CX_AGENT = "AskForCallFromCxAgent",
  CAN_RESUME_DIRECT_TO_CUSTOMER = "CanResumeDirectToCustomer",
  CART_ACCESSORY_BUNDLE = "CartAccessoryBundle",
  COLOMBIA_AUTO_LOADING = "ColombiaAutoLoading",
  ECOMMERCE_ONLY = "EcommerceOnly",
  ECOMMERCE_PARTNER_DOWN_PAYMENT = "EcommercePartnerDownPayment",
  EXCLUDE_CLERK_PII = "ExcludeClerkPII",
  FACEBOOK_FRAUD_DETECT_OPTIONAL = "facebookFraudDetectOptional",
  IN_STORE_PAYMENTS_ENABLED = "InStorePaymentsEnabled",
  IN_STORE_PAYMENTS_NEW_UI_ENABLED = "JLLInStorePayments",
  INCODE_WEBFLOW = "IncodeWebflow",
  LOGIN_PERSONS = "LoginPersons",
  NEW_OFFERS_UI = "NewOffersUi",
  OPENPAY_DOWN_PAYMENT = "openpayDownPayment",
  PAY_AT_DOWN_PAYMENT = "payAtDownPayment",
  PESPAY_DOWN_PAYMENT = "pespayDownPayment",
  PIX_DOWN_PAYMENT = "pixDownPayment",
  QR_CODE_LOGIN = "QrCodeLogin",
  REQUIRES_CLERK_PII = "RequiresClerkPII",
  SHOW_SUSPICIOUS_SALE_FLAG = "ShowSuspiciousSaleFlag",
  USE_ADA_CHATBOT_AUTO_TRIGGER = "UseAdaChatbotAutoTrigger",
  USE_ADD_ON_SERVICES = "UseAddOnServices",
  USE_AUTO_APPROVAL = "UseAutoApproval",
  USE_CART_VERIFICATION = "UseCartVerification",
  USE_CART_VERIFICATION_FOR_CLARO = "UseCartVerificationForClaro",
  USE_CART_VERIFICATION_FOR_KIOSK = "UseCartVerificationForKiosk",
  USE_CART_VERIFICATION_FOR_KIOSK_PE = "UseCartVerificationForKioskPe",
  USE_CART_VERIFICATION_FOR_TIGO = "UseCartVerificationForTigo",
  USE_CREDIT_CHECK_PERMISSION_PAGE = "UseCreditCheckPermissionPage",
  USE_DEFAULT_PRICING = "UseDefaultPricing",
  USE_EVERTEC_VOUCHER = "UseEvertecVoucher",
  USE_FACEBOOK_FRAUD_DETECTION = "useFacebookFraudDetection",
  USE_FINISH_SALE_CHANNEL_SELECTOR = "UseFinishSaleChannelSelector",
  USE_GEO_BLOCK = "UseGeoBlock",
  USE_GEO_BLOCK_SALES_OUTSIDE_STORE = "UseGeoBlockSalesOutsideStore",
  USE_GEOFENCE = "UseGeofence",
  USE_ONE_TIME_PASSWORD = "UseOneTimePassword",
  USE_ONE_TIME_PASSWORD_V2 = "UseOneTimePasswordV2",
  USE_PAYJOY_VOUCHER = "UsePayJoyVoucher",
  USE_PAYJOY_VOUCHER_LIGHTWEIGHT = "UsePayJoyVoucherLightweight",
  USE_PERSON_MANAGEMENT_SYSTEM = "UsePersonManagementSystem",
  USE_PURCHASE_CONFIRMATION_PAGE = "UsePurchaseConfirmationPage",
  USE_QUICK_APPROVAL_FLOW = "UseQuickApprovalFlow",
  USE_SELF_ONBOARDING = "UseSelfOnboarding",
  USE_SPEED_MONEY = "UseSpeedMoney",
  USE_SUNSHINE_CHATBOT_AUTHENTICATION = "UseSunshineChatBotAuthentication",
  USE_TRUSTONIC_UNLOCK = "UseTrustonicUnlock",
  USE_VOUCHER_CODES = "UseVoucherCodes",
  USE_ZENDESK_HELP_PAGE = "UseZendeskHelpPage",
  REUSE_KYC_FLOW = "ReuseKycFlow",
  USE_RENTAL_MODEL = "UseRentalModel",
  USE_SUBSCRIPTION_MODEL = "UseSubscriptionModel",
}

export default MerchantFlags;
